import _ from 'lodash';
import * as Backbone from "backbone";
import {invokeLastFunc} from 'util/FuncUtil';

/**
 * only controls SelPanView.status modes
 */
export const FavCustomizeView = Backbone.View.extend({
	className: 'FavCustomizeView',
	events: {
		'click [data-favcustomizeview="enter"]': 'enter',
		'click [data-favcustomizeview="save"]': 'save',
		'click [data-favcustomizeview="abort"]': 'abort',
	},
	initialize: function (options) {
		_.bindAll(this, _.functionsIn(this));
		this.selpan = options.selpan;
		this.fav = options.fav;
		this.delayed = invokeLastFunc(this, ['render'], 20);
		this.listenTo(this.selpan.status, "change", this.delayed.render);
		this.listenTo(this.fav.custom, "update reset change", this.delayed.render);
		this.listenTo(this.selpan, 'showUserQuestion', this.showUserQuestion);
		this.render();
	},
	enter: function (evt) {
		let mode = this.getMenuRegion(evt);
		if (mode) this.selpan.status.set(mode, true);
		return false; //consume event
	},
	/**
	 *
	 * @param {Object} data
	 * @param {$.Deferred} data.receiverDefer
	 */
	showUserQuestion: function (data) {
		if (!data || !data.receiverDefer) return;
		if (this.receiverDefer && this.receiverDefer.state() === 'pending') this.receiverDefer.reject();
		this.receiverDefer = data.receiverDefer;
		this.receiverDefer.always(this.render);
		this.render();
	},
	save: function () {
		if (this.receiverDefer) this.receiverDefer.resolve();
		return false; //consume event
	},
	abort: function () {
		if (this.receiverDefer) this.receiverDefer.reject();
		return false; //consume event
	},
	getMenuRegion: function (evt) {
		let $t = this.$(evt.target);
		let $regionHolder = $t.closest('[data-menuregion]', this.el);
		let region = $regionHolder.attr('data-menuregion');
		return region || '';
	},
});